import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

type CardProps = HTMLAttributes<HTMLElement> & {
  as?: 'div' | 'section' | 'article' | 'li';
  /** The one most important card on a screen (2px ink border). */
  emphasized?: boolean;
  padded?: boolean;
  children: ReactNode;
};

export function Card({
  as: Tag = 'div',
  emphasized = false,
  padded = true,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <Tag
      className={cn(
        'bg-surface rounded-xl',
        emphasized ? 'border-2 border-ink' : 'border border-line',
        padded && 'p-5 md:p-7',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
